export default () => ({
    cardItem: {
        display: 'flex',
        flexGrow: 1,
        alignSelf: 'center',
        fontSize: '0.875rem',
        '& .digits': {
            fontWeight: 400,
            lineHeight: '1.46em',
        },
        '& .brand': {
            color: 'rgba(0, 0, 0, 0.5)',
            lineHeight: '1.57em',
        },
        '& > .cardIcon': {
            float: 'left'
        }
    }
});
